import { cssRule } from 'typestyle'
import * as csstips from 'csstips'

cssRule('.DialogMask', {
    background: 'rgba(0, 0, 0, 0.5)',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1000
})

cssRule('.DialogWrap', {
    'position': 'absolute',
    'left': '50%',
    'top': '50%',
    'transform': 'translateX(-50%) translateY(-50%)',
    'borderRadius': 12,
    'background': '#fff',
    '-webkit-transform': 'translateX(-50%) translateY(-50%)',
    'padding': '30px 20px 20px 20px',
    'width': 290
})

cssRule('.Dialog_btn button', {
    background: '#fff',
    boxShadow: '0 1px 5px 0 rgba(0,0,0,.1)',
    borderRadius: 20,
    fontSize: 18,
    color: '#999',
    width: 120,
    height: 40,
    textAlign: 'center',
    lineHeight: '40px',
    outline: 'none',
    border: 'none'
})

cssRule('.Dialog_btn .checkBtn', {
    background: '#ff5a31',
    color: '#fff',
    boxShadow: '0 1px 5px 0 rgba(255,90,49,.5)',
    $nest: {
        '&:active': {
            backgroundColor: '#e4431b'
        }
    }
})

cssRule('.Dialog_btn .warnBtn', {
    background: '#f44336',
    color: '#fff',
    boxShadow: '0 1px 5px 0 rgba(255,90,49,.5)',
    $nest: {
        '&:active': {
            backgroundColor: '#df3327'
        }
    }
})

cssRule('.Dialog_btn .cancelBtn', {
    $nest: {
        '&:active': {
            backgroundColor: '#f8f8f8'
        }
    }
})

cssRule('.Dialog_btn', {
    display: 'flex',
    justifyContent: 'space-between'
})

cssRule('.Dialog_title', {
    color: '#333333',
    fontSize: 18,
    fontWeight: 600,
    textAlign: 'center'
})

cssRule('.DialogContent .Dialog_subTitle', {
    marginBottom: 17,
    fontSize: 14,
    lineHeight: '20px',
    textAlign: 'center',
    marginTop: 17
})



// WEBPACK FOOTER //
// ./src/components/Dialog/Dialog.style.ts